export default __webpack_public_path__ + "static/media/search-v2.46f83f6b.svg";